import SpinLoading from '../spinLoading'
// import { Spinner } from '../spinner'
import styled from 'styled-components'

const StyledWrapper = styled.div<{ $isFixed?: boolean }>`
  display: flex;
  overflow: auto;
  min-height: 100vh;

  ${(props) => {
    if (props.$isFixed) {
      return `
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.2);
        z-index: 2;
      `
    }

    return ''
  }}
`

const StyledSpinnerWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`
export type FullScreenLoaderProps = { isShowMenu?: boolean; isFixed?: boolean }
const FullScreenLoader = ({ isFixed }: FullScreenLoaderProps) => {
  return (
    <SpinLoading loading>
      <StyledWrapper $isFixed={isFixed}>
        <StyledSpinnerWrapper>{/* <Spinner /> */}</StyledSpinnerWrapper>
      </StyledWrapper>
    </SpinLoading>
  )
}

export default FullScreenLoader
